import { render, staticRenderFns } from "./horario.vue?vue&type=template&id=0e61373c&"
import script from "./horario.vue?vue&type=script&lang=js&"
export * from "./horario.vue?vue&type=script&lang=js&"
import style0 from "./horario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports